export const capitalizeFirstLetter = (string) => {
    if (!string) return "Unavailable";
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const compareStringWithoutCase = (string1, string2) => {
    return (!!string1 && !!string2) ? string1.toLowerCase() === string2.toLowerCase() : false
}

export const calculateTime = (totalSeconds = 0) => {
    let hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    let minutes = Math.floor(totalSeconds / 60);
    let seconds = Math.round(totalSeconds % 60);

    minutes = String(minutes).padStart(2, "0");
    seconds = String(seconds).padStart(2, "0");
    hours = String(hours).padStart(2, "0");
    if (hours.toString() === '00') {
        return `${minutes}:${seconds}`;
    }
    else {
        return `${hours}:${minutes}:${seconds}`;
    }
}

export const formatTimestamp = (timestamp) => {
    if (!timestamp) return '';
    return timestamp.includes(',') ? timestamp.split(',')[0] : timestamp;
}